import { store } from "./store.js";

const MAX_TOASTS = 3;
const DURATIONS_MS = { success: 3000, info: 4000, warning: 6000, error: 10000 };

let nextId = 1;

// Fila FIFO com no máximo 3 toasts simultâneos — ver
// docs/07-dashboard/DASHBOARD_UI_SPECS.md "Notificações Toast".
export function pushToast(severity, message) {
  const toast = { id: nextId++, severity, message, createdAt: Date.now() };

  store.toasts.set((toasts) => {
    const next = [...toasts, toast];
    return next.length > MAX_TOASTS ? next.slice(next.length - MAX_TOASTS) : next;
  });

  // Todas as severidades auto-dismiss no seu prazo (error: 10s); o botão de
  // fechar manual (renderizado pelo componente Toast) chama dismissToast antes
  // disso independente da severidade.
  const duration = DURATIONS_MS[severity] ?? DURATIONS_MS.info;
  setTimeout(() => dismissToast(toast.id), duration);
  return toast.id;
}

export function dismissToast(id) {
  store.toasts.set((toasts) => toasts.filter((t) => t.id !== id));
}
